import { type ReactElement } from "react";
import image from "@/assets/images/avatar.webp";
import { useScrollReveal } from "@/hooks";
import { useLanguage } from "@/context";
import { Label } from "@/components";
import { t } from "@/data";

const EXPERIENCE = [
  { role: "AI Software Engineer", company: "Sofka Technologies", period: "Feb 2026 — Present" },
  { role: "Mid Senior Developer", company: "Pikul Group", period: "Mar 2025 — Feb 2026" },
  { role: "Software Development Consultant", company: "Sofka Technologies", period: "Feb 2022 — Mar 2025" },
  { role: "Web Developer Junior", company: "Mr Valdemar", period: "Apr 2021 — Oct 2021" },
  { role: "Web Developer", company: "Pixel Graphic", period: "Jul 2020 — Apr 2021" },
] as const;

export const AboutMe = (): ReactElement => {
  const { ref, revealed } = useScrollReveal<HTMLElement>();
  const { lang } = useLanguage();

  return (
    <section id="aboutMe" ref={ref} className={`aboutMe scroll-reveal${revealed ? " revealed" : ""}`} aria-label={t(lang, "aboutMeSection")}>
      <div className="container">
        <Label text={t(lang, "aboutMeLabel")} labelType="open" />
        <div className="description">
          <p>{t(lang, "aboutMeText")}</p>
          <img src={image} alt={t(lang, "profileAlt")} loading="lazy" />
          <div className="timeline" role="list" aria-label={t(lang, "workExperience")}>
            {EXPERIENCE.map((exp, i) => (
              <div
                className={`timeline-item${i === 0 ? " current" : ""}${revealed ? " visible" : ""}`}
                key={i}
                role="listitem"
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                <div className="timeline-dot" aria-hidden="true" />
                <div className="timeline-content">
                  <span className="timeline-role">{exp.role}</span>
                  <span className="timeline-company">{exp.company}</span>
                  <span className="timeline-period">{exp.period}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Label text={t(lang, "aboutMeCloseLabel")} labelType="close" />
      </div>
    </section>
  );
};
